export const INBOX_LIST = 'INBOX_LIST'; 
export const INBOX_LIST_SUCCESS = 'INBOX_LIST_SUCCESS'; 
